import CustomLabel from './custom-label';

export default CustomLabel;
